import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomProductComercialComponent} from './custom-product-comercial.component';
import {CmsConfig, ConfigModule} from '@spartacus/core';


@NgModule({
  declarations: [CustomProductComercialComponent],
  imports: [CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCommercialTabComponent: {
          component: CustomProductComercialComponent,
        },
      },
    } as CmsConfig)],
})
export class CustomProductComercialModule { }
